import { cn } from '@/lib/utils';
import type { VehicleListing } from '@/models/registry';
import { Button } from '../../ui/button';
import { STATUS_OPTIONS_MAP } from './vehicle-status-selector';

export const VehicleStatusBadge = ({
  value,
  hideCopy = false,
  buttonRef,
  className,
  buttonVariant = 'ghost',
}: {
  value: VehicleListing['status'];
  hideCopy?: boolean;
  buttonRef?: React.RefObject<HTMLButtonElement | null>;
  className?: string;
  buttonVariant?: 'outline' | 'ghost';
}) => {
  const option = STATUS_OPTIONS_MAP.find((option) => option.value === value);

  return (
    <Button
      variant={buttonVariant}
      className={cn('p-1 h-fit', className)}
      ref={buttonRef}
    >
      {option?.icon}
      {!hideCopy && (
        <p className="rounded text-xs  text-gray-600">
          {STATUS_OPTIONS_MAP.find((option) => option.value === value)?.label}
        </p>
      )}
    </Button>
  );
};
